import React from 'react';

import type { BreakpointComponent } from '../../../../../core/data-sources/content-components/types.js';

interface GroupDescriptionProps {
  item: BreakpointComponent;
}

const GroupDescription: React.FC<GroupDescriptionProps> = ({ item }) =>
  item.presentationProperties?.description && (
    <div className="short-group-description">
      {item.presentationProperties.description}
    </div>
  );

export default GroupDescription;
